<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <base-alert class="mb-4" />
        <div class="card-outlined p-4">
          <h1 class="text-subtitle-underline">{{ t('account.change_nickname.title') }}</h1>
          <form @submit.prevent="onSubmit">
            <div class="mb-4">
              <label
                for="nickname"
                class="form-label"
              >
                {{ t('word.nickname') }}
              </label>
              <input
                v-model="nickname"
                id="nickname"
                name="nickname"
                type="text"
                :placeholder="t('word.nickname')"
                :class="`form-input mb-1 ${errors['nickname'] ? 'border-red-500' : ''}`"
              >
              <p class="form-error-text">{{ errors['nickname'] }}</p>
            </div>
            <div class="flex items-center pt-2">
              <base-form-submit :disabled="btnDisabled" :text="t('word.change')" />
            </div>
          </form>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { axios } from '@/plugins/axios'
import { ALERT_COLORS } from '@/store/base'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseAlert from '@/components/BaseAlert.vue'

type AccountChangeNicknameValues = {
  nickname: string
}

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseFormSubmit,
    BaseAlert
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues: AccountChangeNicknameValues = {
      nickname: store.state.user.user?.nickname ?? '',
    }

    const schema = yup.object({
      nickname: yup.string().required().max(255),
    })
    const { handleSubmit, errors } = useForm<AccountChangeNicknameValues>({
      validationSchema: schema,
      initialValues
    })
    const { value: nickname } = useField<string>('nickname')
    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-nickname', values)
        .then(response => {
          store.commit('user/setUser', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('account.change_nickname.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      nickname,
      onSubmit,
      btnDisabled
    }
  }
})
</script>
